<template>
  <div
    v-if="url"
    v-edit="'ButtonLabel'"
    class="link-wrapper"
    :class="classes"
    @click="simulateClickOnLink"
  >
    <a
      v-if="url"
      ref="linkWrapperATag"
      v-edit:block="editBlock"
      class="link-wrapper__link"
      :target="target"
      :href="url"
      @click.stop="trackClick()"
    >{{ title }}</a>
    <svgicon
      class="link-wrapper__icon"
      name="Navigation/ArrowRight"
    />
  </div>
</template>

<script>
import dataLayer from '@/analytics/dataLayer'
import "#/Navigation/ArrowRight"

export default {
  name: "LinkWrapper",
  props: {
    classes: {
      type: String,
      default: ''
    },
    editBlock: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Läs mer"
    },
    url: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: "_self"
    },
    tracking: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  methods: {
    simulateClickOnLink () {
      this.$refs.linkWrapperATag.click()
    },
    trackClick () {
      dataLayer.add({
        event: 'linkWrapper',
        linkName: this.title,
        linkUrl: !/^https?:\/\//i.test(this.url) ? window.location.origin + this.url : this.url,
        ...this.tracking
      })
    }
  }
}
</script>

<style lang="scss">
  .link-wrapper {
    $this: &;

    cursor: pointer;

    &__link,
    &__icon {
      transition-property: color, background-color, fill;
      transition-duration: 100ms;
      transition-timing-function: ease-in-out;
      color: $color-secondary-cta-text;
      text-decoration: none;
    }

    &__link {
      @include font(text, 3, "bold");
    }

    &__icon {
      width: 1.5rem;
      height: 1.5rem;
      fill: $color-secondary-cta-text;
    }

    &:active {
      #{$this}__link {
        color: $color-red-dark;
      }

      #{$this}__link + #{$this}__icon {
        fill: $color-red-dark;
      }
    }

    &:hover {
      #{$this}__link {
        color: $color-pink-light;
      }

      #{$this}__link + #{$this}__icon {
        fill: $color-pink-light;
      }
    }
  }
</style>
